import React, { Component, useReducer } from 'react';
import {Collapse,Nav,NavItem,NavLink,UncontrolledDropdown,
 Button, Input, Row, Col, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Form, Container, Label, InputGroup} from "reactstrap";
import axios from 'axios';
import { withCookies, Cookies } from 'react-cookie';
import { instanceOf } from 'prop-types';
import {Helmet} from 'react-helmet'
import {Backend_Url} from './backend_url'
import Background_Image from '../images/image_3.jpg'


  class About extends Component{
    static propTypes = {
      cookies: instanceOf(Cookies).isRequired
    };
    constructor(props) { 
      super(props);
      this.state = {

      };
      this.HandleChange = (e) =>{
        this.setState({[e.target.name]: e.target.value});
      };
    }

    componentDidMount() {

    }




    render() {
      return (
        <div style={{backgroundImage: "url(" + Background_Image + ")"}}>
          <div style={{opacity: 0.9, minHeight: '550px'}}>
            <Helmet>
              <title>ABOUT - ONFIT</title>
              {/* <meta name="description" content="" /> */}
            </Helmet>
            <Container>
              <br/><br/>
              <h4  style={{color: '#3C1874', fontWeight: 'bold'}}>
                  ABOUT ONFIT
              </h4>
              <br/><br/><br/>
              <p style={{textAlign: 'center'}}>
                A Virtual Personal Training Platform that provides a two way interaction between trainers and users.
                <br/>
                Its a first of its kind platform that enables fitness profesionals to manage clients, create customisable training and nutrition plans, track progress, acquire new clients and host live sessions all in one.
                <br/>
                Users have a access to a wide variety of personal trainers tailored to suit their needs at anytime and anywhere they are and can be a part of a community of other fitness users.
              </p>
            </Container>
            <br/><br/><br/>
          </div>
        </div>
      );
    }

  };
  
  export default withCookies(About);